import { useRef, useState } from 'react';
import React from 'react';
// import toast from 'react-hot-toast';

import { BiBug } from 'react-icons/bi';
import { IoMdClose } from 'react-icons/io';
import { useAnalysisActions } from '../hooks/useAnalysisActions';

const BugReportForm = ({ onClose }: { onClose: () => void }) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [message, setMessage] = useState('');

  const { reportBug } = useAnalysisActions();

  const handleMsgChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setMessage(value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    try {
      reportBug(message);
    } finally {
      onClose();
    }
  };

  return (
    <div
      ref={popupRef}
      className="max:w-[500px] m-auto rounded-lg bg-neutralBG px-5 py-4 dark:bg-neutralBG-dark"
    >
      <form name="form-bug" id="form-bug" onSubmit={handleSubmit}>
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center">
            <BiBug className="mb-0.5 mr-2 text-xl opacity-70 sm:text-2xl" />
            <span>Reporter un bug</span>
          </div>
          <div>
            <span
              data-tooltip-content="Revenir à l'écran d'analyse"
              data-tooltip-id="tooltip"
              data-tooltip-place="bottom"
              data-tooltip-delay-show={100}
              data-tooltip-offset={0}
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md bg-[#efefef] opacity-90 transition-all duration-100 hover:bg-[#ededed] hover:opacity-100 dark:bg-[#333135] dark:hover:bg-[#545454]"
              onClick={onClose}
            >
              <IoMdClose className="text-2xl" />
            </span>
          </div>
        </div>
        <div className="grid">
          <div className="col-span-2">
            <textarea
              id="form-textarea-bug"
              name="form-textarea-bug"
              onKeyDown={(e) => e.key === 'Escape' && onClose}
              onChange={handleMsgChange}
              cols={50}
              rows={10}
              className="w-full resize-none rounded-md border-neutralText border-opacity-20 bg-[transparent] dark:border-neutralText-dark dark:border-opacity-20"
              placeholder="Votre message..."
            ></textarea>
          </div>
          <div className="col-span-2 text-right">
            <button
              type="submit"
              className="text-md mt-2 rounded-md bg-[#efefef] px-4 py-2 opacity-90 transition-all duration-100 hover:bg-[#ededed] hover:opacity-100 dark:bg-[#333135] dark:hover:bg-[#545454]"
            >
              Envoyer
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BugReportForm;
